<div class="container">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'map.sidebar.psa.actions.title_edit_rel' | translate }}</h5>
  </div>

  <div class="my-3">
    <b>{{ relData.azione.nome }}</b>

    <div class="form-container">
      <ebw-monorepo-rank-selector-perc
        [valueRank]="relData.riduzione_probabilita"
        (rankChange)="relData.riduzione_probabilita = $event"
        [defaultValue]="0"
        [label]="'Efficacia'"
      ></ebw-monorepo-rank-selector-perc>

      <div
        *ngFor="
          let field of [
            { label: 'Responsabile', model: 'responsabile' },
            { label: 'Pianificazione', model: 'pianificazione' },
            { label: 'Avanzamento', model: 'avanzamento' },
            { label: 'Costi', model: 'costi' },
            { label: 'Validazione', model: 'validazione' },
            { label: 'Tipologia di Monitoraggio', model: 'tipologia_di_monitoraggio' },
            { label: 'Parametro Monitorato', model: 'parametro_monitorato' }
          ]
        "
      >
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ field.label }}</mat-label>
          <input matInput [(ngModel)]="relData[field.model]" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-end gap-3">
    <button mat-button type="button" (click)="onCancel()">
      {{ 'map.sidebar.psa.risk_event.button_cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" (click)="onSave()">
      {{ 'map.sidebar.psa.risk_event.button_save' | translate }}
    </button>
  </div>
</div>
